import { graphic as graphicRegister } from 'echarts/core';

export function install(graphic: typeof graphicRegister) {
  // 例如 为echarts扩展图形echarts.graphic.extendShape
  const Pin = graphic.extendShape({
    type: 'pin',
    shape: {
      // x, y on the cusp
      x: 0,
      y: 0,
      width: 0,
      height: 0
    },

    buildPath(path, shape) {
      const { x, y } = shape;
      const w = (shape.width / 5) * 3;
      // Height must be larger than width
      const h = Math.max(w, shape.height);
      const r = w / 2;

      // Dist on y with tangent point and circle center
      const dy = (r * r) / (h - r);
      const cy = y - h + r + dy;
      const angle = Math.asin(dy / r);
      // Dist on x with tangent point and circle center
      const dx = Math.cos(angle) * r;

      const tanX = Math.sin(angle);
      const tanY = Math.cos(angle);

      const cpLen = r * 0.6;
      const cpLen2 = r * 0.7;

      path.moveTo(x - dx, cy + dy);

      path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
      path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
      path.bezierCurveTo(
        x,
        y - cpLen2,
        x - dx + tanX * cpLen,
        cy + dy + tanY * cpLen,
        x - dx,
        cy + dy
      );
      path.closePath();
    }
  });

  graphic.registerShape('pin', Pin);
}
